import { EMPTY } from '../../../../../../../common/ui/constants.tsx';
import { isEmpty } from '../../../../../../../common/utils/time/index.tsx';

export const validateName = (name: string): string | undefined => {
	if (isEmpty(name)) {
		return EMPTY;
	}

	return undefined;
};
